// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doc-link[data-v-20883092],\n.doc-link[data-v-20883092]:visited,\n.doc-link[data-v-20883092]:hover,\n.doc-link[data-v-20883092]:focus {\n  color: #000 !important;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
